import React from "react";
import { useState, useEffect } from "react";
import PageTitle from "../../Module/pageTitle";
import {
  getMessageList,
  addSupportMessage,
  updateCourseSupportResolve,
  uploadSupportMedia,
  getTeacherHelpDeskMessagesList,
  addHelpDeskMessage,
  updateResolveTeacherIssue,
  getRaiseIssueMessageList,
  getRaiseIssueTeacherMessageList,
  addTeacherIssue,
  addAdminIssue,
  closeRaiseIssue,
  uploadTeacherHelpdeskImage,
  uploadIssueImage,
  issueTypeList,
  issueRemark,
  issueDuration,
  getCourseSupportList,
} from "../../Action/courseAction";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import "./chat.css";
import moment from "moment";
import DescriptionIcon from "@mui/icons-material/Description";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import { useNavigate } from "react-router-dom";
import ImageIcon from "@mui/icons-material/Image";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import KeyboardHideIcon from "@mui/icons-material/KeyboardHide";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ChatImagePopup from "../../Component/chatImagePopup";
import {
  startsWithSpace,
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace,
  length_FiveHundred,
  length_Ten,
  validateNameWithoutSpace,
} from "../../Utils/validators";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import LabelField from "../../Component/labelField";
import CustomDropdown from "../../Component/customDropdown";
import { tokenTypeList } from "../../Utils/dataConstants";
import {
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg,
  validateFullNameErrMsg,
} from "../../Utils/errorMsg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SupportCard from "../../Module/supportCard";
import { useSelector } from "react-redux";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReactHtmlParser from "react-html-parser";
import HtmlTextEditor from "../../Component/HtmlTextEditor";
import katex from "katex";
import "katex/dist/katex.min.css";

// ── Math (LaTeX) in chat messages ────────────────────────────────────────────
// Supported delimiters: $$…$$ and \[…\] (display), \(…\) and $…$ (inline).
// Inline $…$ must not start/end with a space or be followed by a digit, so
// prices like "$5 and $10" aren't treated as maths.
const MATH_REGEX =
  /(\$\$[\s\S]+?\$\$|\\\[[\s\S]+?\\\]|\\\([\s\S]+?\\\)|\$(?!\s)[^$\n]+?(?<!\s)\$(?!\d))/g;
const MATH_TOKEN = new RegExp(`^${MATH_REGEX.source}$`);

const decodeBasicEntities = (s) =>
  s
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&");

// Renders one delimited math token to KaTeX HTML (never throws — bad LaTeX
// is shown in red by KaTeX instead).
const mathTokenToHtml = (token) => {
  let expr;
  let displayMode = false;
  if (token.startsWith("$$")) {
    expr = token.slice(2, -2);
    displayMode = true;
  } else if (token.startsWith("\\[")) {
    expr = token.slice(2, -2);
    displayMode = true;
  } else if (token.startsWith("\\(")) {
    expr = token.slice(2, -2);
  } else {
    expr = token.slice(1, -1);
  }
  return katex.renderToString(decodeBasicEntities(expr).trim(), {
    throwOnError: false,
    displayMode,
  });
};

// For HTML messages: swap math tokens for KaTeX HTML before parsing.
// Plain-text caret notation outside formulas: I^A, X^H, p^r, 10^23, x^{n-1}
// → superscript. Exponent = {group}, one letter, or a (signed) number.
const CARET_REGEX = /([A-Za-z0-9)\]])\^(\{[^}]+\}|[A-Za-z]|[+-]?\d+)/g;
const caretExponent = (exp) => (exp.startsWith("{") ? exp.slice(1, -1) : exp);

// Applies caret superscripts to text only — HTML tags are left untouched.
const caretToSupHtml = (html) =>
  html
    .split(/(<[^>]+>)/)
    .map((part) =>
      part.startsWith("<")
        ? part
        : part.replace(
            CARET_REGEX,
            (_, base, exp) => `${base}<sup>${caretExponent(exp)}</sup>`,
          ),
    )
    .join("");

// For HTML messages: formulas → KaTeX HTML, then caret notation in the
// remaining (non-formula) text → <sup>.
const renderMathInHtml = (html) => {
  if (typeof html !== "string") return html;
  return html
    .split(MATH_REGEX)
    .map((chunk) =>
      MATH_TOKEN.test(chunk) ? mathTokenToHtml(chunk) : caretToSupHtml(chunk),
    )
    .join("");
};

// Same caret → superscript for plain-text messages, as React nodes.
const caretToSupNodes = (text, keyPrefix) => {
  if (typeof text !== "string" || !text.includes("^")) return text;
  const nodes = [];
  let last = 0;
  let match;
  CARET_REGEX.lastIndex = 0;
  while ((match = CARET_REGEX.exec(text))) {
    const [whole, base, exp] = match;
    nodes.push(text.slice(last, match.index) + base);
    nodes.push(
      <sup key={`${keyPrefix}-${match.index}`}>{caretExponent(exp)}</sup>,
    );
    last = match.index + whole.length;
  }
  nodes.push(text.slice(last));
  return nodes;
};

const Chat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const _id = location.state?.id.toString();
  const Name = location.state?.userId;
  const status = location.state?.status;
  const screenName = location?.state?.screeName;
  const queryNo = location?.state?.query;
  const parentCourse = location.state?.baseCourseId;
  const examName = location.state?.examTypeId;
  const subExamName = location.state?.subExamTypeId;
  const startDate = location.state?.startDate;
  const endDate = location.state?.endDate;
  const teacherName = location.state?.teacherId;
  const batchName = location.state?.courseId;
  const issue = location.state?.issue;
  const subjectName = location.state?.subjectId;
  const counsellorName = location.state?.counsellorId;

  const [openImage, setOpenImage] = useState(false);
  const [imageFull, setImageFull] = useState();
  const [openKeyboardLayout, setOpenKeyboardLayout] = useState(false);
  const [open, setOpen] = useState(false);
  const [openRemark, setOpenRemak] = useState(false);
  const [openTokenType, setOpenTokenType] = useState(false);
  const [messages, setMessages] = useState([]);
  const [userId, setUserID] = useState("");
  const [message, setMessage] = useState("");
  const [query, setQuery] = React.useState(0);
  const [tokenType, setTokenType] = useState("");
  const [resetTokenType, setResetTokenType] = useState(false);
  const [issueList, setIssueList] = useState([]);
  const [issueType, setIssueType] = useState("");
  const [remark, setRemark] = useState("");
  const [suppList, setSuppList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(1);
  const [selectedSupportID, setSelectedSupportID] = useState("");
  const [selectedStudentName, setSelectedStudentName] = useState("");

  const { userInfo } = useSelector((state) => ({
    userInfo: state.Auth?.userInfo,
  }));

  useEffect(() => {
    start(_id, Name);
    setSelectedStatus(status);
    setSelectedSupportID(_id);
    setSelectedStudentName(Name);
    if (screenName === "technicalSupport") {
      const reqBody = {
        skip: 0,
        startDate,
        endDate,
        status: status,
        supportType: 1,
      };
      if (examName?._id) reqBody.examTypeId = examName?._id;
      if (parentCourse?._id) reqBody.baseCourseId = parentCourse?._id;
      dispatch(
        getCourseSupportList(reqBody, (res) => {
          if (res?.data?.data?.length > 0) setSuppList(res?.data?.data);
          else setSuppList([]);
        }),
      );
    } else {
      const postdata = {
        skip: 0,
        supportType: 2,
        status: status,
        baseCourseId: parentCourse?._id,
        examTypeId: examName?._id,
        // courseId: batchName?._id,
      };
      if (subExamName) {
        postdata["subExamTypeId"] = subExamName?._id;
      }
      if (subjectName) {
        postdata["subjectId"] = subjectName?._id;
      }
      dispatch(
        getCourseSupportList(postdata, (res) => {
          if (res?.data?.data?.length > 0) setSuppList(res?.data?.data);
          else setSuppList([]);
        }),
      );
    }
  }, []);

  const scrollBottom = () => {
    let elem = document.getElementById("messegeBox");
    elem.scrollTop = elem.scrollHeight;
  };
  const start = (cId, selectedIssue) => {
    setSelectedSupportID(cId);
    setSelectedStudentName(
      selectedIssue?.userId ? selectedIssue?.userId : Name,
    );
    if (screenName === "helpdesk" || screenName === "infrasupport")
      dispatch(
        getTeacherHelpDeskMessagesList(
          _id,
          location?.state?.isTeacher,
          (res) => {
            setUserID(res[0]?.helpDeskId);
            setQuery(res[0]?.queryNo);
            setMessages(res);
            scrollBottom();
          },
          () => {},
        ),
      );
    else if (
      screenName === "InfraIssue" ||
      screenName === "raiseIssue" ||
      screenName === "helpdesk"
    )
      dispatch(
        getRaiseIssueMessageList(
          _id,
          {
            adminId: userInfo?._id,
          },
          (res) => {
            setUserID(res[0]?.to?._id);
            setMessages(res);
            scrollBottom();
          },
          () => {},
        ),
      );
    else if (screenName === "raiseIssueTeacher")
      dispatch(
        getRaiseIssueTeacherMessageList(
          _id,
          {
            adminId: userInfo?._id,
          },
          (res) => {
            setUserID(res[0]?.from?._id);
            setMessages(res);
            scrollBottom();
          },
          () => {},
        ),
      );
    else if (screenName === "helpdesk" || screenName === "infrasupport")
      dispatch(
        getTeacherHelpDeskMessagesList(
          _id,
          true,
          (res) => {
            setUserID(res[0]?.helpDeskId);
            setQuery(res[0]?.queryNo);
            setMessages(res);
            scrollBottom();
          },
          () => {},
        ),
      );
    else
      dispatch(
        getMessageList(
          cId ? cId : _id,
          {
            userId: userInfo?._id,
          },
          (res) => {
            setUserID(res[0]?.from?._id);
            setMessages(res);
            scrollBottom();
          },
          () => {},
        ),
      );
  };

  const onBack = () => {
    if (screenName === "technicalSupport") {
      navigate("../technicalSupport", {
        state: {
          baseCourseId: parentCourse,
          screeName: "chat",
          selectedStatus,
          examTypeId: examName,
          counsellorId: counsellorName,
          startDate,
          endDate,
          issue,
        },
      });
    } else if (screenName === "raiseIssue") {
      navigate("../editdeleteraiseissue", {
        state: {
          startDate,
          endDate,
          baseCourseId: parentCourse,
          teacherName,
          screeName: "chat",
          status: selectedStatus,
        },
      });
    } else if (screenName === "InfraIssue") {
      navigate("../editdeleteissue", {
        state: {
          startDate,
          endDate,
          teacherName,
          screeName: "chat",
          status: selectedStatus,
        },
      });
    } else if (screenName === "infrasupport") {
      navigate("../infraissue", {
        state: {
          startDate,
          endDate,
          screeName: "chat",
        },
      });
    } else if (screenName === "courseSupport") {
      navigate("../courseSupport", {
        state: {
          screeName: "chat",
          status: selectedStatus,
          baseCourseId: parentCourse,
          examTypeId: examName,
          subExamTypeId: subExamName,
          courseId: batchName,
        },
      });
    }
  };
  const handleRemark = () => {
    setOpenRemak(true);
    dispatch(
      issueTypeList((res) => {
        setIssueList(res);
      }),
    );
  };
  const handleCloseRemark = () => {
    setOpenRemak(false);
  };
  const changeRemark = (value) => {
    if (value?.length >= length_FiveHundred) {
      dispatch(
        showErrorSnackbar(
          `Max Length ${length_FiveHundred} reached for this field`,
        ),
      );
    } else if (
      containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace(value)
    ) {
      dispatch(
        showErrorSnackbar(
          containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg,
        ),
      );
    } else if (!validateNameWithoutSpace(value)) {
      dispatch(showErrorSnackbar(validateFullNameErrMsg));
    } else {
      setRemark(value);
    }
  };
  const handelSubmit = (e) => {
    e.preventDefault();
    const postData = {
      issueTypeId: issueType?._id,
      remark: remark,
    };
    dispatch(
      issueRemark(_id, postData, (res) => {
        setOpenRemak(false);
        document.querySelectorAll("textarea").forEach((el) => (el.value = ""));
        if (res?.status === "success") {
          dispatch(
            issueDuration({
              helpDeskId: _id,
              teacherId: selectedStudentName.toString(),
            }),
          );
          dispatch(
            updateResolveTeacherIssue(
              userId,
              () => {
                if (screenName === "infrasupport") {
                  navigate("../infraissue", {
                    state: {
                      startDate,
                      endDate,
                      screeName: "chat",
                    },
                  });
                } else if (screenName === "helpdesk") {
                  navigate("../helpdesk");
                }
                // navigate("../teachersupport");
              },
              () => {},
            ),
          );
        }
      }),
    );
  };
  const handleClose = () => {
    setOpenImage(false);
  };
  const handleCloseTokenType = () => {
    setOpenTokenType(false);
  };

  const handleOnClick = () => {
    setOpenImage(true);
  };

  const changeTokenType = (value) => {
    setTokenType(value);
    setResetTokenType(false);
  };

  const handleNewUserMessage = () => {
    if (screenName === "helpdesk" || screenName === "infrasupport") {
      const data = {
        adminId: userInfo?._id,
        queryNo: query,
        issueMessage: message,
        helpDeskId: userId,
      };
      dispatch(
        addHelpDeskMessage(
          data,
          location.state?.isTeacher,
          (res) => {
            if (res) {
              setMessage("");
              start(selectedSupportID);
            }
          },
          () => {},
        ),
      );
    } else if (screenName === "raiseIssueTeacher") {
      const data = {
        adminId: userInfo?._id,
        raiseIssueId: _id,
        issueMessage: message,
        queryNo,
      };
      dispatch(
        addTeacherIssue(
          data,
          (res) => {
            if (res) {
              setMessage("");
              start(selectedSupportID);
            }
          },
          () => {},
        ),
      );
    } else if (screenName === "raiseIssue" || screenName === "InfraIssue") {
      const data = {
        adminId: userInfo?._id,
        raiseIssueId: _id,
        issueMessage: message,
        queryNo,
      };
      dispatch(
        addAdminIssue(
          data,
          (res) => {
            if (res) {
              setMessage("");
              start(selectedSupportID);
            }
          },
          () => {},
        ),
      );
    } else {
      const data = {
        adminId: userInfo?._id,
        message: message,
        messageType: 1,
        supportId: selectedSupportID,
        to: userId ? userId : selectedStudentName?._id,
      };
      dispatch(
        addSupportMessage(
          data,
          (res) => {
            if (res) {
              setMessage("");
              start(selectedSupportID);
              const reqBody = {
                skip: 0,
                startDate,
                endDate,
                status: selectedStatus,
                supportType: 1,
              };
              if (examName?._id) reqBody.examTypeId = examName?._id;
              if (parentCourse?._id) reqBody.baseCourseId = parentCourse?._id;
              dispatch(
                getCourseSupportList(reqBody, (res) => {
                  if (res?.data?.data?.length > 0) setSuppList(res?.data?.data);
                  else setSuppList([]);
                }),
              );
            }
          },
          () => {},
        ),
      );
    }
  };

  const onClickKeybaordLayout = () => {
    if (!openKeyboardLayout) {
      setOpenKeyboardLayout(true);
    } else {
      setOpenKeyboardLayout(false);
    }
  };

  const handleChange = (e, val) => {
    setOpen(!open);
    const fileSizeKiloBytes = e.target.files[0].size / 1024;
    const fileSizeKiloBytesPdf = e.target.files[0].size / 1024;
    if (parseInt(fileSizeKiloBytes) > 15360 && val === 1) {
      dispatch(showErrorSnackbar("Image size should be less than 15 MB!!!"));
    } else if (parseInt(fileSizeKiloBytesPdf) > 10240 && val === 2) {
      dispatch(showErrorSnackbar("File size should be less than 10 MB!!!"));
    } else {
      if (e.target?.files?.length > 0) {
        uploadMedia(e.target.files[0], val);
      }
    }
  };

  const uploadMedia = async (val, type) => {
    if (screenName === "helpdesk" || screenName === "infrasupport") {
      dispatch(
        uploadTeacherHelpdeskImage(val, (res) => {
          const data = {
            adminId: userInfo?._id,
            queryNo: query,
            // issueMessage: message,
            helpDeskId: userId,
            image: res?.file,
          };
          dispatch(
            addHelpDeskMessage(
              data,
              location.state?.isTeacher,
              (res) => {
                if (res) {
                  setMessage("");
                  start(selectedSupportID);
                }
              },
              () => {},
            ),
          );
        }),
      );
    } else if (screenName === "raiseIssue" || screenName === "InfraIssue") {
      dispatch(
        uploadIssueImage(val, (imageResponse) => {
          const data = {
            adminId: userInfo?._id,
            raiseIssueId: _id,
            queryNo,
            image: imageResponse?.file,
          };
          dispatch(
            addAdminIssue(
              data,
              (res) => {
                if (res) {
                  setMessage("");
                  start(selectedSupportID);
                }
              },
              () => {},
            ),
          );
        }),
      );
    } else if (screenName === "raiseIssueTeacher") {
      dispatch(
        uploadIssueImage(val, (imageResponse) => {
          const data = {
            adminId: userInfo?._id,
            raiseIssueId: _id,
            queryNo,
            image: imageResponse?.file,
          };
          dispatch(
            addTeacherIssue(
              data,
              (res) => {
                if (res) {
                  setMessage("");
                  start(selectedSupportID);
                }
              },
              () => {},
            ),
          );
        }),
      );
    } else {
      dispatch(
        uploadSupportMedia(val, type, (res) => {
          if (res) {
            const data = {
              adminId: userInfo?._id,
              messageType: 2,
              supportId: selectedSupportID,
              to: userId ? userId : selectedStudentName?._id,
              mediaFile: res,
            };
            data["mediaFile"].type = type;
            dispatch(
              addSupportMessage(data, () => {
                setMessage("");
                start(selectedSupportID);
              }),
            );
          }
        }),
      );
    }
  };

  const openPdf = (link) => {
    window.open(link);
  };

  const handleResolveIssue = (IssueId) => {
    if (screenName === "helpdesk" || screenName === "infrasupport")
      handleRemark();
    else if (screenName === "raiseIssue" || screenName === "InfraIssue") {
      handleRemark();
      dispatch(
        closeRaiseIssue(
          `${IssueId}`,
          () => {
            // navigate("../editDeleteRaiseIssue");
            if (screenName === "raiseIssue") {
              navigate("../editdeleteraiseissue", {
                state: {
                  startDate,
                  endDate,
                  baseCourseId: parentCourse,
                  teacherName,
                  screeName: "chat",
                  status: selectedStatus,
                },
              });
            } else if (screenName === "InfraIssue") {
              navigate("../editdeleteraiseissue", {
                state: {
                  startDate,
                  endDate,
                  teacherName,
                  screeName: "chat",
                  status: selectedStatus,
                },
              });
            }
          },
          () => {},
        ),
      );
    } else {
      if (screenName === "technicalSupport") {
        setOpenTokenType(true);
      } else {
        dispatch(
          updateCourseSupportResolve(
            {
              adminId: userInfo?._id,
            },
            IssueId,
            () => {
              if (screenName === "courseSupport") {
                navigate("../courseSupport", {
                  state: {
                    screeName: "chat",
                    status: selectedStatus,
                  },
                });
              } else {
                navigate("../technicalSupport", {
                  state: {
                    baseCourseId: parentCourse,
                    screeName: "chat",
                    selectedStatus,
                    examTypeId: examName,
                    counsellorId: counsellorName,
                    startDate,
                    endDate,
                    issue,
                  },
                });
              }
              if (screenName === "DoubtSolveReview") {
                navigate("../DoubtSolveReview");
              }
            },
            () => {},
          ),
        );
      }
    }
  };

  const validations = () => {
    return message?.length == 0;
  };

  const saveAndUpdate = (IssueId) => {
    let postData = {
      issue: tokenType?.value,
      adminId: userInfo?._id,
    };
    dispatch(
      updateCourseSupportResolve(
        postData,
        IssueId,
        () => {
          navigate("../technicalSupport", {
            state: {
              baseCourseId: parentCourse,
              screeName: "chat",
              selectedStatus,
              examTypeId: examName,
              counsellorId: counsellorName,
              startDate,
              endDate,
              issue,
            },
          });
        },
        () => {},
      ),
    );
  };

  const showData = (val) => {
    setSelectedStatus(val);

    const reqBody = {
      skip: 0,
      startDate,
      endDate,
      status: val,
      supportType: 1,
    };
    if (examName?._id) reqBody.examTypeId = examName?._id;
    if (parentCourse?._id) reqBody.baseCourseId = parentCourse?._id;
    dispatch(
      getCourseSupportList(reqBody, (res) => {
        if (res?.data?.data?.length > 0) {
          setSuppList(res?.data?.data);
          start(selectedSupportID, selectedStudentName);
        } else {
          setSuppList([]);
          setUserID("");
          setMessages([]);
          setSelectedStudentName("");
          setSelectedSupportID("");
        }
      }),
    );
  };

  const renderTextMessage = (text) => {
    if (!text) return null;

    // Keep a multi-line $$…$$ / \[…\] formula on one line so the line-by-line
    // parsing below doesn't cut it apart.
    const lines = String(text)
      .replace(/\$\$[\s\S]+?\$\$|\\\[[\s\S]+?\\\]/g, (m) =>
        m.replace(/\n/g, " "),
      )
      .split("\n");
    const elements = [];
    let listBuffer = [];
    let listType = null; // 'ul' | 'ol'

    const flushList = (key) => {
      if (!listBuffer.length) return;
      const ListTag = listType === "ol" ? "ol" : "ul";
      elements.push(
        <ListTag key={`list-${key}`} className="mb-1 ps-4">
          {listBuffer.map((itemText, i) => (
            <li key={i}>{renderInlineMarkdown(itemText)}</li>
          ))}
        </ListTag>,
      );
      listBuffer = [];
      listType = null;
    };

    lines.forEach((line, index) => {
      if (isBulletLine(line)) {
        if (listType !== "ul") flushList(index);
        listType = "ul";
        listBuffer.push(line.replace(/^\s*[-*•]\s+/, ""));
        return;
      }

      if (isNumberedLine(line)) {
        if (listType !== "ol") flushList(index);
        listType = "ol";
        listBuffer.push(line.replace(/^\s*\d+\.\s+/, ""));
        return;
      }

      flushList(index);

      if (!line?.trim()) {
        elements.push(<div key={index} style={{ height: "4px" }} />);
        return;
      }

      // "Key: value" styling — but not when the first colon is inside a
      // formula (e.g. "$f: A \to B$").
      const colonIdx = line.indexOf(":");
      const beforeColon = colonIdx === -1 ? "" : line.slice(0, colonIdx);
      if (colonIdx === -1 || /\$|\\\(|\\\[/.test(beforeColon)) {
        elements.push(
          <div key={index} className="mb-1">
            {renderInlineMarkdown(line)}
          </div>,
        );
        return;
      }

      const [key, ...value] = line.split(":");
      elements.push(
        <div key={index} className="mb-1">
          <span className="fw-bold">{renderInlineMarkdown(key)}:</span>{" "}
          {renderInlineMarkdown(value.join(":").trim())}
        </div>,
      );
    });

    flushList("end");
    return elements;
  };

  // Math first (so "*" / "_" inside LaTeX aren't read as bold / italics),
  // then the existing bold / italic / link markdown on the remaining text.
  const renderInlineMarkdown = (str) => {
    if (!str) return str;

    return str.split(MATH_REGEX).map((chunk, ci) => {
      if (!chunk) return null;
      if (MATH_TOKEN.test(chunk)) {
        return (
          <span
            key={`m${ci}`}
            className="chat-math"
            dangerouslySetInnerHTML={{ __html: mathTokenToHtml(chunk) }}
          />
        );
      }
      return (
        <React.Fragment key={`t${ci}`}>
          {renderMarkdownText(chunk)}
        </React.Fragment>
      );
    });
  };

  const renderMarkdownText = (str) => {
    if (!str) return str;

    const regex = /(\*\*.*?\*\*|\*.*?\*|_.*?_|\[.*?\]\(.*?\))/g;
    const parts = str.split(regex);

    return parts.map((part, i) => {
      if (!part) return null;

      if (/^\*\*.*\*\*$/.test(part)) {
        return (
          <strong key={i}>{caretToSupNodes(part.slice(2, -2), `b${i}`)}</strong>
        );
      }

      if (/^\*.*\*$/.test(part) || /^_.*_$/.test(part)) {
        return <em key={i}>{caretToSupNodes(part.slice(1, -1), `e${i}`)}</em>;
      }

      const linkMatch = part.match(/^\[(.*?)\]\((.*?)\)$/);
      if (linkMatch) {
        const [, label, url] = linkMatch;
        return (
          <a
            key={i}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary"
            onClick={(e) => e.stopPropagation()}
          >
            {label}
          </a>
        );
      }

      return (
        <React.Fragment key={i}>
          {caretToSupNodes(part, `t${i}`)}
        </React.Fragment>
      );
    });
  };

  const isBulletLine = (line) => /^\s*[-*•]\s+/.test(line);
  const isNumberedLine = (line) => /^\s*\d+\.\s+/.test(line);

  return (
    <div className="contentBox">
      <div className="row mx-0">
        <div className="col-sm-9 p-0 mb-2">
          <div className="p-lg-3 pb-lg-0">
            <div className="shadow-none rounded">
              <PageTitle name="Chat" />
            </div>
            <div className="userInfo d-flex msgheader bg-blue border-0 Title shadow-none p-0">
              <h5 className="text-white">
                {screenName === "technicalSupport" ||
                screenName === "raiseIssue" ||
                screenName === "InfraIssue" ||
                screenName === "infrasupport" ||
                screenName === "courseSupport" ? (
                  <button
                    type="submit"
                    className="nav-btn-bgcolor border-0 mx-4"
                    onClick={() => onBack()}
                  >
                    <ArrowBackIosIcon />
                  </button>
                ) : null}
                {screenName === "helpdesk" ||
                screenName === "raiseIssue" ||
                screenName === "raiseIssueTeacher" ||
                screenName === "infrasupport" ||
                screenName === "InfraIssue"
                  ? `${selectedStudentName?.name}`
                  : `${
                      selectedStudentName?.firstName
                        ? selectedStudentName?.firstName
                        : ""
                    } ${
                      selectedStudentName?.lastName
                        ? selectedStudentName?.lastName
                        : ""
                    }`}
              </h5>
              <div>
                {selectedStatus !== 3 ? (
                  <>
                    {screenName === "helpdesk" ||
                    screenName === "raiseIssue" ||
                    screenName === "infrasupport" ||
                    screenName === "raiseIssueTeacher" ||
                    screenName === "InfraIssue" ? (
                      <>
                        {!location?.state?.isTeacher ? (
                          <button
                            className="add_Question-btn btn btn btn-success btn-md me-2"
                            onClick={() => handleResolveIssue(_id)}
                          >
                            Close Issue
                          </button>
                        ) : null}
                      </>
                    ) : (
                      <button
                        className="btn me-2 btn-success"
                        onClick={() => handleResolveIssue(selectedSupportID)}
                      >
                        <TaskAltIcon fontSize="large" sx={{ color: "white" }} />
                      </button>
                    )}
                    <button
                      className="btn btn-primary me-2"
                      onClick={() => start(selectedSupportID)}
                    >
                      <RefreshIcon fontSize="large" sx={{ color: "white" }} />
                    </button>
                  </>
                ) : null}
              </div>
            </div>
            <div className="chat-container">
              <div className="messegeBox p-2 border" id="messegeBox">
                {messages !== undefined
                  ? messages.map((item) => {
                      const {
                        message,
                        createdAt,
                        issueMessage,
                        mediaFile,
                        messageFrom,
                        from,
                        image,
                      } = item;

                      const getParsedMessage = (msg) => {
                        if (!msg) return "";

                        try {
                          return JSON.parse(msg);
                        } catch {
                          return msg;
                        }
                      };
                      const parsedMessage = getParsedMessage(message);

                      const isHtml = (str) => {
                        return /<\/?[a-z][\s\S]*>/i.test(str);
                      };

                      const renderMessage = (parsedMessage) => {
                        // Case 1: Object with FAQ
                        if (
                          typeof parsedMessage === "object" &&
                          parsedMessage?.faq
                        ) {
                          return (
                            <>
                              {/* Questions */}
                              {parsedMessage.faq.map((ele, idx) => (
                                <div key={idx} className="mb-2">
                                  <button className="btn btn-outline-primary rounded-pill font12">
                                    {ele?.question}
                                  </button>
                                </div>
                              ))}
                            </>
                          );
                        }

                        // Case 2: Answer array (object format)
                        if (Array.isArray(parsedMessage)) {
                          return parsedMessage.map((ans, idx) => {
                            if (ans?.type === 1) {
                              return (
                                <p key={ans._id || idx} className="mb-1 font12">
                                  {ReactHtmlParser(
                                    renderMathInHtml(ans.content),
                                  )}
                                </p>
                              );
                            }

                            if (ans?.type === 2) {
                              return (
                                <img
                                  key={ans._id || idx}
                                  src={ans.content}
                                  alt=""
                                  className="chatimg mb-2 me-2 cursor"
                                  onClick={() => {
                                    handleOnClick();
                                    setImageFull(ans.content);
                                  }}
                                />
                              );
                            }

                            return null;
                          });
                        }

                        // Case 3: Single object answer
                        if (typeof parsedMessage === "object") {
                          return (
                            <div className="mb-1 font12">
                              {parsedMessage?.content ||
                                parsedMessage?.question}
                            </div>
                          );
                        }

                        // Case 4: Normal string
                        return (
                          <div>
                            {isHtml(message)
                              ? ReactHtmlParser(renderMathInHtml(parsedMessage))
                              : renderTextMessage(parsedMessage)}
                          </div>
                        );
                      };
                      const isJsonObject =
                        typeof parsedMessage === "object" &&
                        parsedMessage !== null;

                      <div>
                        {moment
                          .utc(item.createdAt)
                          .format("DD-MMM-YYYY, hh:mm A")}
                      </div>;
                      if (screenName === "helpdesk") {
                        if (
                          messageFrom === (location?.state?.isTeacher ? 1 : 2)
                        )
                          return (
                            <>
                              <div className="requestMsg">
                                {image ? (
                                  <div
                                    onClick={() => {
                                      handleOnClick();
                                      setImageFull(image);
                                    }}
                                  >
                                    <img
                                      className="chatimg"
                                      src={image}
                                      alt={image}
                                    />
                                  </div>
                                ) : null}
                                <div className="text-dark font-16">
                                  {issueMessage}
                                </div>
                                <div className="font-11">
                                  {" "}
                                  {moment(createdAt).format(
                                    "DD-MMM-YYYY, hh:mm A",
                                  )}{" "}
                                </div>
                              </div>
                            </>
                          );
                        else
                          return (
                            <>
                              <div className="responseMsg">
                                {image ? (
                                  <div
                                    onClick={() => {
                                      handleOnClick();
                                      setImageFull(image);
                                    }}
                                  >
                                    <img
                                      className="chatimg"
                                      src={image}
                                      alt={image}
                                    />
                                  </div>
                                ) : null}
                                <div className="text-dark font-16">
                                  {issueMessage}
                                </div>
                                <div className="font-11-req-msg">
                                  {" "}
                                  {moment(createdAt).format(
                                    "DD-MMM-YYYY, hh:mm A",
                                  )}{" "}
                                </div>
                              </div>
                            </>
                          );
                      } else if (
                        screenName === "helpdesk" ||
                        screenName === "infrasupport"
                      ) {
                        if (messageFrom === 2)
                          return (
                            <>
                              <div className="requestMsg">
                                {image ? (
                                  <div
                                    onClick={() => {
                                      handleOnClick();
                                      setImageFull(image);
                                    }}
                                  >
                                    <img
                                      className="chatimg"
                                      src={image}
                                      alt={image}
                                    />
                                  </div>
                                ) : null}
                                <div className="text-dark font-16">
                                  {issueMessage}
                                </div>
                                <div className="font-11">
                                  {" "}
                                  {moment(createdAt).format(
                                    "DD-MMM-YYYY, hh:mm A",
                                  )}{" "}
                                </div>
                              </div>
                            </>
                          );
                        else
                          return (
                            <>
                              <div className="responseMsg">
                                {image ? (
                                  <div
                                    onClick={() => {
                                      handleOnClick();
                                      setImageFull(image);
                                    }}
                                  >
                                    <img
                                      className="chatimg"
                                      src={image}
                                      alt={image}
                                    />
                                  </div>
                                ) : null}
                                <div className="text-dark font-16">
                                  {issueMessage}
                                </div>
                                <div className="font-11-req-msg">
                                  {" "}
                                  {moment(createdAt).format(
                                    "DD-MMM-YYYY, hh:mm A",
                                  )}{" "}
                                </div>
                              </div>
                            </>
                          );
                      } else if (isJsonObject ? true : from?._id !== userId) {
                        if (
                          item.messageType === 1 ||
                          screenName === "raiseIssue" ||
                          screenName === "raiseIssueTeacher" ||
                          screenName === "InfraIssue"
                        ) {
                          return (
                            <>
                              <div className="requestMsg">
                                {image ? (
                                  <div
                                    onClick={() => {
                                      handleOnClick();
                                      setImageFull(image);
                                    }}
                                  >
                                    <img
                                      className="chatimg"
                                      src={image}
                                      alt={image}
                                    />
                                  </div>
                                ) : null}

                                <div className="text-dark font-16">
                                  {/* {message} */}
                                  {renderMessage(parsedMessage)}
                                </div>
                                <div className="font-11">
                                  {" "}
                                  {moment(createdAt).format(
                                    "DD-MMM-YYYY, hh:mm A",
                                  )}{" "}
                                </div>
                              </div>
                            </>
                          );
                        } else {
                          const filename = mediaFile?.originalName;
                          return (
                            <>
                              <div className="requestMsg">
                                <div>
                                  {filename && filename.includes("pdf") ? (
                                    <div
                                      className="cursor"
                                      onClick={() => openPdf(mediaFile?.file)}
                                    >
                                      <PictureAsPdfIcon />
                                      <span className="d-block">
                                        {mediaFile?.originalName}
                                      </span>
                                    </div>
                                  ) : filename && filename.includes("mp3") ? (
                                    <>
                                      <div>
                                        <audio controls>
                                          <source
                                            src={mediaFile?.file}
                                            type="audio/ogg"
                                          />
                                        </audio>
                                      </div>
                                    </>
                                  ) : (
                                    <div>
                                      <div
                                        onClick={() => {
                                          handleOnClick();
                                          setImageFull(mediaFile);
                                        }}
                                      >
                                        <img
                                          className="chatimg"
                                          src={mediaFile?.file}
                                          alt={mediaFile?.originalName}
                                        />
                                      </div>
                                    </div>
                                  )}
                                  <div className="font-11">
                                    {moment(createdAt).format(
                                      "DD-MMM-YYYY, hh:mm A",
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        }
                      } else {
                        if (
                          item.messageType === 1 ||
                          screenName === "raiseIssue" ||
                          screenName === "raiseIssueTeacher" ||
                          screenName === "InfraIssue"
                        ) {
                          return (
                            <>
                              <div className="responseMsg">
                                {image ? (
                                  <div
                                    onClick={() => {
                                      handleOnClick();
                                      setImageFull(image);
                                    }}
                                  >
                                    <img
                                      className="chatimg"
                                      src={image}
                                      alt={image}
                                    />
                                  </div>
                                ) : null}
                                <div className="text-dark font-16">
                                  {/* {message} */}
                                  {renderMessage(parsedMessage)}
                                </div>
                                <div className="font-11-req-msg">
                                  {" "}
                                  {moment(createdAt).format(
                                    "DD-MMM-YYYY, hh:mm A",
                                  )}{" "}
                                </div>
                              </div>
                            </>
                          );
                        } else {
                          const filename = mediaFile?.originalName;

                          return (
                            <>
                              <div className="responseMsg">
                                <div>
                                  {filename && filename.includes("pdf") ? (
                                    <div
                                      className="cursor"
                                      onClick={() => openPdf(mediaFile?.file)}
                                    >
                                      <PictureAsPdfIcon />
                                      <span className="d-block">
                                        {mediaFile?.originalName}
                                      </span>
                                    </div>
                                  ) : filename && filename.includes("mp3") ? (
                                    <>
                                      <div>
                                        <audio
                                          controls
                                          controlsList="nodownload noplaybackrate"
                                        >
                                          <source
                                            src={mediaFile?.file}
                                            type="audio/ogg"
                                          />
                                        </audio>
                                      </div>
                                    </>
                                  ) : (
                                    <div>
                                      <div
                                        onClick={() => {
                                          handleOnClick();
                                          setImageFull(mediaFile);
                                        }}
                                      >
                                        {renderMessage(parsedMessage)}
                                        <img
                                          className="chatimg"
                                          src={mediaFile?.file}
                                          alt={mediaFile?.originalName}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="font-11-req-msg">
                                  {moment(createdAt).format(
                                    "DD-MMM-YYYY, hh:mm A",
                                  )}
                                </div>
                              </div>
                            </>
                          );
                        }
                      }
                    })
                  : null}
              </div>
              {openKeyboardLayout && (
                <div
                  className={`editor-wrapper ${
                    openKeyboardLayout ? "open" : ""
                  }`}
                >
                  <HtmlTextEditor
                    onChange={(value) => setMessage(value)}
                    value={message}
                    height={"100px"}
                  />
                </div>
              )}
              {selectedStatus !== 3 ? (
                <>
                  <div className="chatBottom border px-1">
                    {/* <div className="removelabel w-100">
                    <textarea
                      rows="3"
                      className="form-control border border-0"
                      placeholder={"Enter Messege Here"}
                      onChange={(e) => {
                        if (startsWithSpace(e.target.value)) {
                          dispatch(showErrorSnackbar("space not allowed"));
                          return;
                        } else {
                          setMessage(e.target.value);
                        }
                      }}
                      maxLength={length_FiveHundred}
                      minLength={length_Ten}
                      value={message}
                    />
                  </div> */}
                    <div className="ms-2 mt-2 d-flex align-items-center">
                      <span className="p-3 position-absolute rounded d-flex justify-content-between">
                        <span className="text-center mb-2">
                          <p className="mediaicon">
                            <span
                              className="mx-2 cursor"
                              onClick={() => onClickKeybaordLayout()}
                            >
                              {openKeyboardLayout ? (
                                <KeyboardHideIcon />
                              ) : (
                                <KeyboardIcon />
                              )}
                            </span>
                          </p>
                        </span>
                        <span className="text-center ms-3 mb-2">
                          <p className="mediaicon">
                            <span className="mx-2 cursor">
                              <label htmlFor="upload-button" className="cursor">
                                <ImageIcon />
                              </label>
                              <input
                                type="file"
                                id="upload-button"
                                style={{ display: "none" }}
                                onChange={(e) => handleChange(e, 1)}
                                accept="image/png, image/gif, image/jpeg"
                              />
                            </span>
                          </p>
                        </span>
                        {![
                          "raiseIssue",
                          "raiseIssueTeacher",
                          "InfraIssue",
                          "helpdesk",
                          "infrasupport",
                        ].includes(screenName) && (
                          <span className="text-center ms-3 mb-2">
                            <p className="mediaicon">
                              <span className="mx-2 cursor">
                                <label
                                  htmlFor="upload-button1"
                                  className="cursor"
                                >
                                  <DescriptionIcon />
                                </label>
                                <input
                                  type="file"
                                  id="upload-button1"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleChange(e, 2)}
                                  accept=".pdf"
                                />
                              </span>
                            </p>
                          </span>
                        )}
                      </span>
                      <div className="text-end me-2">
                        <button
                          type="submit"
                          className="btn btn-primary submitbtn rounded-pill mb-2"
                          onClick={handleNewUserMessage}
                          disabled={validations()}
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div className="col-sm-3 p-0 border border-1 rounded mb-2 mt-3">
          <div className="">
            <div className="d-flex justify-content-center align-item-center py-1">
              <h3>Support Chat</h3>
            </div>
            <div className="px-2">
              <ul className="nav d-flex mb-3 w-100 py-2">
                <li className="flex-fill " onClick={() => showData(1)}>
                  <button
                    className={`border-0 w-100 rounded-start p-2  ${
                      selectedStatus === 1 ? "nav-btn-bgcolor" : ""
                    }`}
                  >
                    New Issue
                  </button>
                </li>
                <li className="flex-fill " onClick={() => showData(2)}>
                  <button
                    className={`border-0 w-100 p-2 ${
                      selectedStatus === 2 ? "nav-btn-bgcolor" : ""
                    }`}
                  >
                    In progress
                  </button>
                </li>
                <li className="flex-fill" onClick={() => showData(3)}>
                  <button
                    className={`border-0 w-100 rounded-end p-2 ${
                      selectedStatus === 3 ? "nav-btn-bgcolor" : ""
                    }`}
                  >
                    Resolved
                  </button>
                </li>
              </ul>
            </div>
            <div className="p-2 ">
              {suppList?.length !== 0 ? (
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade active show"
                    id="pills-new"
                    role="tabpanel"
                    aria-labelledby="pills-new-tab"
                    tabIndex="0"
                    style={{
                      overflow: "auto",
                      height: "535px",
                    }}
                  >
                    {suppList?.map((item, index) => {
                      return (
                        <SupportCard
                          data={item}
                          key={index}
                          clickhandle={() => start(item?._id, item)}
                          selectedSupportID={selectedSupportID}
                        />
                      );
                    })}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-inprogress"
                    role="tabpanel"
                    aria-labelledby="pills-inprogress-tab"
                    tabIndex="0"
                    style={{
                      overflow: "auto",
                      height: "535px",
                    }}
                  >
                    {suppList?.map((item, index) => {
                      return (
                        <SupportCard
                          data={item}
                          key={index}
                          clickhandle={() => start(item?._id, item)}
                        />
                      );
                    })}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="pills-resolved"
                    role="tabpanel"
                    aria-labelledby="pills-resolved-tab"
                    tabIndex="0"
                    style={{
                      overflow: "auto",
                      height: "535px",
                    }}
                  >
                    {suppList?.map((item, index) => {
                      return (
                        <SupportCard
                          key={index}
                          data={item}
                          clickhandle={() => start(item?._id, item)}
                        />
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className=""> No Issue Found</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ChatImagePopup
        open={openImage}
        handleClose={handleClose}
        imageFull={imageFull}
      />
      {openTokenType ? (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="model"
          open={openTokenType}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openTokenType}>
            <div className="bookstockmodeldiv p-3">
              <div className="col mb-4 d-flex justify-content-between ">
                <p className="fw-bold">
                  <span style={{ color: "#3F51B5" }}> Task Token Update</span>
                </p>
                <ClearOutlinedIcon
                  className="colorPurple cursor"
                  onClick={handleCloseTokenType}
                />
              </div>
              <div className="form-check">
                <div className="d-flex mb-2 align-items-center">
                  <LabelField labelName={"Token Type"} />
                  <CustomDropdown
                    labelName="Select Token Type"
                    setInputText={(value) => changeTokenType(value)}
                    options={tokenTypeList}
                    reset={resetTokenType}
                    Isrequired={true}
                    defaultValue={tokenType?._id}
                  />
                </div>

                <div className="col-auto d-flex justify-content-center mt-5">
                  <button
                    onClick={() => saveAndUpdate(selectedSupportID)}
                    type="submit"
                    className={"btn mb-3 submitbtn btn-primary"}
                  >
                    Save and Update
                  </button>
                </div>
              </div>
            </div>
          </Fade>
        </Modal>
      ) : null}
      {openRemark ? (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="model"
          open={openRemark}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openRemark}>
            <div className="modeldiv p-3">
              <div className="col mb-4 d-flex justify-content-between ">
                <h6 className="colorPurple fw-bold">Remark</h6>
                <ClearOutlinedIcon
                  className="colorPurple cursor"
                  onClick={handleCloseRemark}
                />
              </div>
              <div className="row px-5 form-check">
                <form onSubmit={handelSubmit}>
                  <div>
                    <div className="d-flex align-items-center me-3 ">
                      <LabelField labelName={"Issue Type"} />
                      <CustomDropdown
                        setInputText={(value) => {
                          setIssueType(value);
                        }}
                        value={issueType}
                        options={issueList}
                        labelName="Select Issue Type"
                        Isrequired={true}
                        // reset={resetCategoryType}
                      />
                    </div>
                    <div className="d-flex align-items-center me-3">
                      <LabelField labelName={"Remark"} />
                      <textarea
                        className="form-control"
                        placeholder={"Enter Your Remark Here!"}
                        onChange={(e) => changeRemark(e.target.value)}
                        maxLength={length_FiveHundred}
                        minLength={length_Ten}
                        value={remark}
                      />
                      <span className="required ms-2 ">*</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-evenly mt-5">
                    <button
                      type="submit"
                      className="btn btn-primary px-5 cursor"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Fade>
        </Modal>
      ) : null}
    </div>
  );
};
export default Chat;
